import React from "react";
import Background from  "../Assets/Image/img.png";
import styled from "styled-components";

function Home() {
    return (
        <ContainerSC>
            {/*<ContentSC>*/}
            {/*</ContentSC>*/}
        </ContainerSC>
    )
}

const ContainerSC = styled("div")`
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
`;

const ContentSC = styled.div`
    height: 60%;
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
    background-image: url("${Background}");
    background-repeat: no-repeat;
    background-size: contain;
    font-size: 100px;
`

export default Home;
